import CaisseSelectComplementaire from '@/generated/controls/caisse/CaisseSelectComplementaire.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: CaisseSelectComplementaire
})
